export default __webpack_public_path__ + "static/media/11.ca7c43e7.jpg";